export function setBodyStyles(value: boolean) {
  if (value) {
    document.body.className += 'overflow-hidden';
  } else {
    document.body.className = document.body.className.replace('overflow-hidden', '');
  }
}
